import {h} from 'preact'
import Button from '../ui-components/Button'

interface Props {
  onEdit: () => void
  onDelete: () => void
}

const EditOrDeleteQuickLink = ({onEdit, onDelete}: Props) => (
  <div class='hover'>
    <Button
      type='button'
      class='btn--insided-secondary-brand'
      onClick={onEdit}
    >
      Edit
    </Button>
    <Button
      type='button'
      class='btn--insided-brand btn-danger'
      onClick={onDelete}
    >
      Delete
    </Button>
  </div>
)

export default EditOrDeleteQuickLink
